export default {
  status: 'scheduled',
  invoice_date: '2019-07-01',
  amount: 10000,
  currency: 'NOK',
}
